// src/api.js

// ---- Public API ----
export async function getQueue() {
  const r = await apiFetch('/queue')
  if (!r.ok) throw new Error('NETWORK_ERROR')
  return r.json()
}

export async function bridgeCall(lead_id, staff_id, staff_name) {
  const r = await fetch('/bridge', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Device': getDeviceToken() },
    body: JSON.stringify({ lead_id, staff_id, staff_name })
  })
  if (!r.ok) throw new Error('bridge failed')
  return r.json()
}

export async function setOutcome(lead_id, staff_id, code, extras = {}) {
  const r = await apiFetch('/outcome', {
    method: 'POST',
    body: JSON.stringify({ lead_id, staff_id, code, ...extras })
  })
  if (!r.ok) throw new Error('NETWORK_ERROR')
  return r.json()
}

// Convenience wrapper: reuse /outcome with code='Reschedule'
export async function rescheduleCall(lead_id, staff_id, callback_at) {
  return setOutcome(lead_id, staff_id, 'Rescheduled', { callback_at })
}

export function getDeviceToken() {
  return localStorage.getItem('cc_device_token') || ''
}

export async function enrollDevice(code, device_number) {
  const r = await fetch('/register-device', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code, device_number })
  })
  if (!r.ok) throw new Error('Enroll failed')
  const { device_token } = await r.json()
  localStorage.setItem('cc_device_token', device_token)
  return device_token
}

// NEW: dynamic staff list from backend
export async function getStaff() {
  const r = await apiFetch('/staff', { method: 'GET' })
  if (!r.ok) throw new Error('NETWORK_ERROR')
  return r.json()
}

function forceLogout() {
  try { localStorage.removeItem('cc_device_token') } catch {}
  sessionStorage.setItem('cc_msg', 'Device access revoked. Please re-enroll.')
  location.reload()
}

async function apiFetch(path, opts = {}) {
  const headers = { 'Content-Type': 'application/json', ...(opts.headers || {}) }
  const token = localStorage.getItem('cc_device_token') || ''
  if (token) headers['X-Device'] = token

  const res = await fetch(path, { ...opts, headers })
  if (res.status === 401) {
    forceLogout()
    throw new Error('UNAUTHORIZED')
  }
  return res
}

// (Used by server responses, not required here; keep if you import it elsewhere)
function timeAgo(ts) {
  const s = Math.floor((Date.now() - ts)/1000)
  if (s < 60) return `${s}s ago`
  const m = Math.floor(s/60)
  if (m < 60) return `${m}m ago`
  const h = Math.floor(m/60)
  return `${h}h ago`
}
